/**
 * Content AI permission ids used by create / publish / delivery UI.
 * Kept local to avoid importing generated API permission maps.
 */
export const contentAiPermissions = {
  Contents_Create: 'content-ai:contents:create',
  Contents_SocialPublish: 'content-ai:contents:social-publish',
  Contents_FragmentDelivery: 'content-ai:contents:fragment-delivery',
} as const;
